import React, {useEffect} from "react";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {setError} from "../error/ErrorHandlerSlice";
import {setPage, paginationState} from "./PaginationSlice";

interface PaginationProps {
  readonly disabled: boolean;
  readonly itemsLength: number;
}

const Pagination = (props: PaginationProps) => {
  const {disabled, itemsLength} = props;
  const dispatch = useAppDispatch();
  const {page, limit, error} = useAppSelector(paginationState);

  const isFirstPage = page === 1;
  const isLastPage = itemsLength < limit;

  useEffect(() => {
    if (error) dispatch(setError(error));
  }, [dispatch, error]);

  const onPageSelected = (p: number) => {
    dispatch(setPage(p));
  };

  return (
    <nav aria-label="Page navigation" className="d-flex justify-content-center">
      <ul className="pagination">
        {!isFirstPage && (
          <li className="page-item">
            <button
              className={`page-link ${disabled ? "disabled" : ""}`}
              disabled={disabled}
              onClick={() => {
                onPageSelected(page - 1);
              }}
            >
              Previous
            </button>
          </li>
        )}
        {!isFirstPage && (
          <li className={`page-item ${isFirstPage ? "active" : ""}`}>
            <button
              className={`page-link ${disabled ? "disabled" : ""}`}
              disabled={disabled}
              onClick={() => {
                onPageSelected(page - 1);
              }}
            >
              {page - 1}
            </button>
          </li>
        )}
        <li className="page-item active">
          <button className={`page-link ${disabled ? "disabled" : ""}`} disabled={disabled}>
            {page}
          </button>
          <span className="sr-only">(current)</span>
        </li>
        {!isLastPage && (
          <li className="page-item">
            <button
              className={`page-link ${disabled ? "disabled" : ""}`}
              disabled={disabled}
              onClick={() => {
                onPageSelected(page + 1);
              }}
            >
              {page + 1}
            </button>
          </li>
        )}
        {!isLastPage && (
          <li className="page-item">
            <button
              className={`page-link ${disabled ? "disabled" : ""}`}
              disabled={disabled}
              onClick={() => {
                onPageSelected(page + 1);
              }}
            >
              Next
            </button>
          </li>
        )}
      </ul>
    </nav>
  );
};

export default Pagination;
